/**
 * DevExtreme (esm/__internal/pagination/editors/common/editor_label_props.js)
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { current, isMaterial } from "../../../../ui/themes";
export const EditorLabelDefaultProps = {
  label: "",
  labelMode: isMaterial(current()) ? "floating" : "static"
};